import { trackSelfDescribingEvent } from "@snowplow/browser-tracker"
import { QUIZ_STEPS } from "./quizSteps"

export default function trackQuizAnswer({
  answers,
  question,
  stepIndex,
}: {
  answers: string[]
  question: string
  stepIndex: number
}) {
  trackSelfDescribingEvent({
    event: {
      data: {
        answers,
        question,
        step: stepIndex + 1,
        steps_total: QUIZ_STEPS.length,
        url: window.location.href,
      },
      schema: "iglu:com.asanarebel/onboarding_event/jsonschema/1-0-0",
    },
  })
}
